import { Component, Output, Input, EventEmitter, OnInit, ChangeDetectorRef, Inject, Injectable } from "@angular/core";
import swal from "sweetalert2";
import { formatDate } from "@angular/common";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { ReportService } from "../../services/report.service";
import { UserService } from "../../services/user.service";

import { GuiGuard } from "../../shared/guard/base-gui-guard";
import { Methods } from "../../shared/methods";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-physical-report",
  templateUrl: "./physical-report.component.html",
  styleUrls: ["./physical-report.component.css"],
  providers: [GuiGuard, ReportService],
})
export class PhysicalReportComponent implements OnInit {
  public mtds: Methods = new Methods();

  @Input() reportID: string;
  @Input() typeReport: string;
  @Input() poReport: string;
  @Input() destructionclientsname: string;

  @Output() out = new EventEmitter<string>();
  public perPage:any = "25";
  public page = 1;
  public total_items_count: 0;
  public token;
  public identity;
  public apikey = "";
  public total_pages:any = 0;

  public summaryResponse: any = {};

  public report;
  public cerrado: boolean = false;

  public loading: boolean = false;
  public loadingDisks: boolean = false;
  public saving: boolean = false;
  public saveunlock: boolean = false;

  public responseDestructionReport: any[] = [];
  public destructionReport: DinamicData;
  /*public destructionReport: DinamicData = new DinamicData(
    ['ID', 'Serial Number', 'Destruction Method', 'REP', 'Date Destroyed', 'Actions']
  );*/

  //DETAILEDPHYSICALDESTRUCTION
  public destructionManuallySerialNumber = "";
  public destructionManuallyMake = "";
  public destructionManuallyModel = "";
  public destructionManuallySerialCapacity = "";
  public destructionManuallyParent = "";

  public summaryTotal = {};
  public reportSaved = 0;

  public itemID;
  public itemsID: Array<any> = [];
  public bulk: Array<number> = [];

  public nuevo = {
    value: "",
    value_two: "",
    change: 0,
  };


  constructor(
    private _reportService: ReportService,
    private _userService: UserService,
    public guard: GuiGuard,
    private _router: Router,
    private _route: ActivatedRoute,
    private ref: ChangeDetectorRef/* ,
    public dialogRef: MatDialogRef<PhysicalReportComponent>,@Inject(MAT_DIALOG_DATA) public data: any */
  ) {
    this.token = this._userService.getToken();
    this.identity = this._userService.getIdentity();
    this.apikey = this.identity.apiCompany;
  }
  closeManifest2() {
/*     this.dialogRef.close(this.reportID);  */
  }
  ngOnInit() {
/*     if(this.data != undefined || this.data != null){
      this.reportID =  this.data.reportID 
      this.typeReport = this.data.typeReport
      this.poReport = this.data.poReport 
      this.destructionclientsname = this.data.destructionclientsname 
    }  */
    if (this.typeReport === "PHYSICALDESTRUCTION") {
      this.destructionReport = new DinamicData([
        "check",
        "ID",
        "Serial Number",
        "Destruction Method",
        "REP",
        "Date Destroyed",
        "Actions",
      ]);
    } else if (this.typeReport === "DETAILEDPHYSICALDESTRUCTION") {
      this.destructionReport = new DinamicData([
        "check",
        "ID",
        "Make",
        "Model",
        "Capacity",
        "Serial Number",
        "Parent",
        "Destruction Method",
        "REP",
        "Date Destroyed",
        "Actions",
      ]);
    }

    if (this.reportID !== null) this.getReport();
  }

  closeReport() {
    this.out.emit(this.reportID);
  }

  /*getReport() {
    this.destructionManuallyMake = "";
    this.destructionManuallyModel = "";
    this.destructionManuallySerialCapacity = "";
    this.destructionManuallySerialNumber = "";

    this.listaReportes = [];
    this.responseDestructionReport = [];
    this.cerrado = false;
    this._reportService
      .getReportByPo(
        this.token,
        this.poSelectedDestruction,
        null,
        this.typeReport
      )
      .subscribe((response) => {
        console.log(response);
        if (response.status === "success") {
          this.currentReport = response.data.id;
          this.cerrado = response.data.name !== "pending";
          this.getReports();
          if (response.data.name === "pending") this.pendingReports = 1;
          else this.pendingReports = 0;
          this.listaReportes.push(response.data);
          console.log(this.listaReportes);
        }
      });
  }*/
  get reportType() {
    if (this.report) {
      return this.report.type == "DATAERASUREREPORT"
        ? "Data Erasure Report"
        : this.report.type == "PHYSICALDESTRUCTION"
        ? "Basic Physical Destruction Report"
        : this.report.type == "PDTEMP"
        ? " Physical Destruction Temporal"
        : this.report.type == "INBOUNDWEIGHTBYDATE"
        ? "In Bound Weight By Date"
        : this.report.type == "INBOUNDWEIGHTBYPO"
        ? "In Bound Weight By PO"
        : this.report.type == "DETAILEDPHYSICALDESTRUCTION"
        ? "Detailed Physical Destruction Report"
        : "";
    }
  }
  getReport() {
    this.loading = true;
    
    this._reportService.getReport(this.token, this.reportID).subscribe(
      (response) => {
        console.log("getReport => ", response);
        if (response.status === "success") {
          this.summaryResponse = JSON.parse(response.data.reportSummary);
          this.report = response.data;
          this.cerrado = response.data.name !== "pending";
          this.getReports();
        }

        this.loading = false;
      },
      (error) => {
        console.log("error");
      }
    );
  }

  doSummary(){
   // this.summaryTotal
  }

  downloadFile(file) {
    window.open(
      "https://www.greenteksolutions.com/web/report/downloadfile/" +
        file +
        "/" +
        this.token,
      "_blank"
    );
  }

  openReport(reporteID, ReporteType) {
    if (ReporteType == "DATAERASUREREPORT")
      window.open(
        "https://www.itaderp.com/backend/reports/view-erasure.php?id=" +
          reporteID +
          "&apitoken=" +
          this.apikey,
        "_blank"
      );
    else if (ReporteType == "INBOUNDWEIGHTBYDATE")
      window.open(
        "https://www.itaderp.com/backend/reports/view-report.php?id=" +
          reporteID +
          "&typeReport=" +
          ReporteType +
          "&apikey=" +
          this.apikey,
        "_blank"
      );
    else if (ReporteType == "INBOUNDWEIGHTBYPO")
      window.open(
        "https://www.itaderp.com/backend/reports/view-report.php?id=" +
          reporteID +
          "&typeReport=" +
          ReporteType +
          "&apikey=" +
          this.apikey,
        "_blank"
      );
    else
      window.open(
        "https://www.itaderp.com/backend/reports/view-report.php?id=" +
          reporteID +
          "&typeReport=" +
          ReporteType +
          "",
        "_blank"
      );
  }

  canUnlock() {
    return this.guard.permissions("unlockPhDR");
  }

  unlock() {
    this.saveunlock = true;
    this._reportService.unlockReport(this.token, this.reportID).subscribe(
      (response) => {
        console.log(response);
        this.cerrado = false;
        this.saveunlock = false;
        this.getReport();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  saveDestructionReport() {
    this.reportSaved = 0;
    this.saving = true;
    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    console.log(fechaHoy);
    // this.responseDestructionReport.push({"clientsname": this.destructionclientsname});
    // var myJSON = JSON.stringify(this.responseDestructionReport);
    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.poReport,
      name: fechaHoy,
      type:
        this.typeReport === "DETAILEDPHYSICALDESTRUCTION"
          ? "DETAILEDPHYSICALDESTRUCTION"
          : "PDTEMP",
      data: null,
    };

    //console.log(dataEnviar);

    if (this.reportID !== null) {
      this.saveDisk(true);
      /*
        this._reportService.update(this.token, this.currentReport, dataEnviar).subscribe(
          response => {
            console.log(response);
            if (response.status == 'success') {
              this.reportSaved = 1;
              this.currentReport = response.data.id;
            }
          },
          error => {
            console.log(<any>error);
          });
      */
    } else {
      this._reportService.new(this.token, dataEnviar).subscribe(
        (response) => {
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
            this.saving = false;
          } else if (response.status === "success") {
            console.log(response);
            this.reportSaved = 1;
            this.reportID = response.data.id;
            this.saveDisk();
            this.getReport();
          } else {
            this.mtds.notifyError(response.msg, response.code);
            this.saving = false;
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
    }
  }

  generateDestructionReport() {
    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    this.responseDestructionReport.push({
      clientsname: this.destructionclientsname,
    });
    var myJSON = JSON.stringify(this.responseDestructionReport);
    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.poReport,
      name: fechaHoy,
      type: this.typeReport,
      data: myJSON,
    };

    if (this.reportID !== null) {
      this._reportService
        .update(this.token, this.reportID, dataEnviar)
        .subscribe(
          (response) => {
            if (response.status == "success") {
              this.getReport();
              this.cerrado = true;
              var r = confirm("Press Ok to see report");
              if (r == true) {
                window.open(
                  "https://www.itaderp.com/backend/reports/view-report.php?id=" +
                    response.data.id +
                    "&typeReport=" +
                    response.data.type +
                    "",
                  "_blank"
                );
                this.responseDestructionReport = [];
              } else {
              }
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
    } else {
      this._reportService.new(this.token, dataEnviar).subscribe(
        (response) => {
          if (response.status == "success") {
            this.cerrado = true;
            var r = confirm("Press Ok to see report");
            if (r == true) {
              window.open(
                "https://www.itaderp.com/backend/reports/view-report.php?id=" +
                  response.data.id +
                  "&typeReport=" +
                  response.data.type +
                  "",
                "_blank"
              );
              this.responseDestructionReport = [];
            } else {
            }
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }
  }

  get isDetailed() {
    return (
      this.typeReport === "DETAILEDPHYSICALDESTRUCTION" &&
      this.poReport !== "" &&
      this.poReport !== null
    );
  }

  getReports(params: any = null) {
    console.log("params => ",params);
    if(params && params.perPage)
      this.perPage = params.perPage;

    if(params && params.page)
      this.page = params.page;
    this.loadingDisks = true;

    this.responseDestructionReport = [];
   // this.summaryTotal = {};
    if (this.reportID !== null) {
      this._reportService
        .getDiscs(this.token, this.reportID, this.page, this.perPage)
        .subscribe((r) => {
          //this.perPage = r.items_per_page;
          this.total_items_count = r.total_items_count;
          this.destructionReport.rows = [];

          let i = 0;
          this.total_pages = r.total_pages;

          for (let item of r.data) {
            i = i + 1;

            let reporte = JSON.parse(item.data);
            reporte.id = item.id;
            let userREP = item.user;
            userREP = item.user.name[0] + item.user.surname[0];
            reporte.user = userREP;

          /*  if (typeof this.summaryTotal[userREP] !== "undefined") {
              this.summaryTotal[userREP]++;
            } else {
              this.summaryTotal[userREP] = 1;
            }*/
            this.responseDestructionReport.push(reporte);
            let actionButtons;
            if (this.report.name === "pending") {
              actionButtons = [
                {
                  icon: "delete_outline",
                  action: "Remove",
                  color: "danger",
                  value: reporte.id,
                },
              ];
            }

            let selected_value = false;

            if(
                this.bulk.includes(reporte.id.toString())
              )
                selected_value = true;

            if (this.typeReport === "DETAILEDPHYSICALDESTRUCTION") {
              this.destructionReport.rows.push([
                new Cell(reporte.id, {type: 'checkbox', selected: selected_value}), // Check box
                new Cell(reporte.id),
                new Cell(reporte.make),
                new Cell(reporte.model),
                new Cell(reporte.capacity),
                new Cell(reporte.SerialNumber),
                new Cell(reporte.parent),
                new Cell("Shredded"),
                new Cell(reporte.user),
                new Cell(reporte.ErasureEndDate),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            } else if (this.typeReport === "PHYSICALDESTRUCTION") {
              this.destructionReport.rows.push([
                new Cell(reporte.id, {type: 'checkbox', selected: selected_value}), // Check box
                new Cell(reporte.id),
                new Cell(reporte.SerialNumber),
                new Cell("Shredded"),
                new Cell(reporte.user),
                new Cell(reporte.ErasureEndDate),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }
          }

          this.loadingDisks = false;
        });
    }
  }

  removeDisk(id) {
    swal.fire({
      title: "",
      text: "Do you want to remove this element?",
  
      showCancelButton: true,
      buttonsStyling: false,
      customClass:{
    confirmButton: 'btn btn-warning',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(
      function (result) {
        if (result.value) {
          this._reportService.removeDiscs(this.token, id).subscribe(
            (response) => {
              console.log(response);
              if (response.status === "success") {
                //this.getReports();
                this.getReport();
                this.mtds.notifySuccess(
                  "The element has been removed successfully"
                );
              } else {
                this.mtds.notifyError(response.msg, response.code);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
        }
      }.bind(this)
    );
  }

  saveDisk(getReports = false) {
    let idrandom = Math.floor(Math.random() * 100 + 1);
    this.destructionManuallySerialNumber =
      this.destructionManuallySerialNumber.replace(".", "");
    let serialnumberenviar = this.destructionManuallySerialNumber;
    let erasuredateneviar = this.getFecha();
    let json: any = {
      id: idrandom,
      SerialNumber: serialnumberenviar,
      ErasureEndDate: erasuredateneviar,
      clientsname: this.destructionclientsname,
    };

    if (this.typeReport === "DETAILEDPHYSICALDESTRUCTION") {
      json = {
        id: idrandom,
        make: this.destructionManuallyMake,
        model: this.destructionManuallyModel,
        capacity: this.destructionManuallySerialCapacity,
        SerialNumber: serialnumberenviar,
        ErasureEndDate: erasuredateneviar,
        clientsname: this.destructionclientsname,
        parent: this.destructionManuallyParent
      };

      this._reportService.enviarDisco(this.token, this.reportID, json).subscribe(
        (response) => {
          console.log(response);
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status === "success") {
            this.destructionManuallySerialNumber = "";
            this.destructionManuallyMake = "";
            this.destructionManuallyModel = "";
            this.destructionManuallySerialCapacity = "";
            this.destructionManuallyParent = "";
            if (getReports) {
              //this.getReports();
              this.getReport();
            }
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
          this.saving = false;
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
    } else {

      json = {
        id: idrandom,
        ErasureEndDate: erasuredateneviar,
        clientsname: this.destructionclientsname,
        value: this.nuevo.value,
        items: this.itemsID
      };

      this._reportService.enviarDiscoBulkReport(this.token, this.reportID, json).subscribe(
        (response) => {
          console.log(response);
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status === "success") {
            
            this.itemsID = [];
            this.itemsID = response.itemID;

            this.nuevo.value = response.itemsCheck;

            if (getReports) {
              //this.getReports();
              this.getReport();
            }
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
          this.saving = false;
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
    }
  }

  getFecha() {
    var fecha = new Date();

    let currentHours = fecha.getHours();
    let currentHoursText = ("0" + currentHours).slice(-2);
    let currentMinutes = fecha.getMinutes();
    let currentMinutesText = ("0" + currentMinutes).slice(-2);
    let currentSeconds = fecha.getSeconds();
    let currentSecondsText = ("0" + currentSeconds).slice(-2);

    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    const anio = fecha.getFullYear();

    const hour = fecha.getTime();

    //console.log(month + '/' + day + '/' + anio + ' ' + currentHoursText + ':' + currentMinutesText + ':' + currentSecondsText);
    return (
      month +
      "/" +
      day +
      "/" +
      anio +
      " " +
      currentHoursText +
      ":" +
      currentMinutesText +
      ":" +
      currentSecondsText
    );
  }

  action(e) {
    console.log("action =>", e);

    switch (e.action) {
      case "Remove": {
        this.removeDisk(e.id);
        break;
      }
      default:
        break;
    }
  }

  deleteFolderfirst(report) {
    swal.fire({
      title: "Are you sure to delete this report?",
      text: "",

      showCancelButton: true,
      buttonsStyling: false,
      customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then(
      function (result) {
        if (result.value) {
          this._reportService.remove(this.token, report).subscribe(
            (response) => {
              if (
                response.code === 400 &&
                response.msg === "Authorization not valid"
              ) {
                this.mtds.notifyError("Your session has expired");
                localStorage.clear();
                this._router.navigate(["/pages/lock"]);
              } else if (response.status === "success") {
                this.mtds.notifySuccess("Report has been removed successfully");
                this.reportID = null;
                this.closeReport();
              } else {
                this.mtds.notifyError(response.msg, response.code);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
              this.closeReport();
            }
          );
        }
      }.bind(this)
    );
  }

  cleanValues() {
    this.itemID = 0;
    this.nuevo.value_two = '';
    this.itemsID = [];
    this.nuevo.value = '';
  }

  removeItemFromArray(id) {

    this.itemsID = this.itemsID.filter((item) => item !== id);
    //this.checkItemsNotFound();

    // Dividir la cadena en un array utilizando el salto de línea como separador
    let idsArray = this.nuevo.value.split(/\s+/);

    // Encontrar el índice del ID a eliminar
    let indexToRemove = idsArray.indexOf(id);

    // Si se encuentra el ID a eliminar, eliminarlo del array
    if (indexToRemove !== -1) {
        idsArray.splice(indexToRemove, 1);
    }

    // Unir los elementos del array de nuevo en una cadena
    this.nuevo.value = idsArray.join('\n');
  }

  changeBulk(evento){
    console.log("evento => ", evento);
    if(evento && evento.cleanall){
      this.bulk =[];
    }
  }

  removeBulkModal(){

    swal.fire({
      title:
        `Are you sure you want to remove these items from this report ${this.poReport}?`,
      showCancelButton: true,
      buttonsStyling: false,
      customClass:{
        cancelButton: 'order-1 btn btn-danger',
        confirmButton: 'order-2 btn btn-success',
      },
      confirmButtonColor: "#4CAF50",
      confirmButtonText: "Yes, Remove",
      icon: "info",
      iconColor: '#C19A0A'
    }).then(
      function (result) {
        if (result.value) {
          this.removeBulk();
        }
      }.bind(this)
    );
  }

  removeBulk() {    

    let json = {
      bulk: this.bulk,
    };

    this._reportService.removeDiscsBulk(this.token, this.reportID, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          swal.fire({
          
            title: "Item(s) has been removed successfully",
            text: "",
            buttonsStyling: false,
         
            customClass:{
              confirmButton: 'btn btn-success'
            },
            icon: "success",
          });

          this.bulk = [];
          this.getReport();
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
}
